const doc = [({"da":({"js":({"merfoto":({"tenant_photo_products":({"add_to_basket_button":({"choose_photos_and_add_to_basket":"Vælg fotos og læg i kurv"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;